import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Title from './Title';

const Clickable = styled.button`
  display: flex;
  border: 0;
  background: none;
  flex-direction: row;
  padding-left: 50px;
  &:focus {
    outline: 0;
  }
`;

const IconContainer = styled.div`
  margin-top 20px;
  margin-left: 30px;
  color: #d2c8ae;
  align-items: center;
  font-size: 24px;
  width: 20px;
`;

const ClickableTitle = ({ text, onClick, icon }) => {
  return (
    <Clickable onClick={onClick}>
      <Title text={text} />
      {icon && <IconContainer>{icon}</IconContainer>}
    </Clickable>
  );
};

ClickableTitle.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func,
  icon: PropTypes.node,
};

export default ClickableTitle;
